type Props = {
  open: boolean;
  phone: string;
  isLoading: boolean;
  cooldownSeconds?: number;
  onClose: () => void;
  onSubmit: () => void;
  saveGuideText: string;
};

export default function MomentTestSendModal({
  open,
  phone,
  isLoading,
  cooldownSeconds = 0,
  onClose,
  onSubmit,
  saveGuideText,
}: Props) {
  if (!open) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-2xl tw-p-6 tw-w-full tw-max-w-sm tw-shadow-xl">
        <h3 className="tw-font-bold tw-text-lg tw-mb-4">테스트 발송</h3>
        <div className="tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-lg tw-px-3 tw-py-2.5 tw-mb-3 tw-text-xs tw-text-blue-700">
          {saveGuideText}
        </div>
        <div className="tw-bg-amber-50 tw-border tw-border-amber-200 tw-rounded-lg tw-px-3 tw-py-2.5 tw-mb-3">
          <ul className="tw-text-xs tw-text-amber-700 tw-space-y-1 tw-list-disc tw-pl-4">
            <li>채널과 친구 관계인 전화번호로만 발송됩니다.</li>
            <li>회원가입한 휴대전화 번호만 입력할 수 있습니다.</li>
            <li>홍보문구에 [테스트 발송] 문구가 추가되어 발송됩니다.</li>
            <li>사용자·광고계정 각각 30초에 1회 제한이 있습니다.</li>
          </ul>
        </div>
        <label className="tw-block tw-text-xs tw-text-gray-500 tw-mb-1">수신 전화번호</label>
        <input
          type="tel"
          placeholder="회원가입한 번호"
          value={phone}
          readOnly
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit();
          }}
          className="tw-w-full tw-border tw-border-gray-300 tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-mb-4 tw-bg-gray-50 tw-text-gray-600 focus:tw-outline-none"
        />
        <p className="tw-text-xs tw-text-gray-400 tw-mt-[-10px] tw-mb-4">회원가입한 휴대전화 번호로만 테스트 발송할 수 있습니다.</p>
        <div className="tw-flex tw-gap-3">
          <button
            onClick={onClose}
            className="tw-flex-1 tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-lg tw-text-sm"
          >
            취소
          </button>
          <button
            onClick={onSubmit}
            disabled={isLoading || cooldownSeconds > 0 || !phone.trim()}
            className="tw-flex-1 tw-px-4 tw-py-2 tw-bg-[#5D87FF] tw-text-white tw-rounded-lg tw-text-sm tw-font-bold tw-border-0 disabled:tw-opacity-50"
          >
            {isLoading ? "발송 중..." : cooldownSeconds > 0 ? `테스트 발송 (${cooldownSeconds})` : "테스트 발송"}
          </button>
        </div>
      </div>
    </div>
  );
}
